import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ManufacturesState } from 'types';

export const initialState: ManufacturesState = {
  loading: false,
  manufactureList: [],
  reset: false
};

const slice = createSlice({
  name: 'Manufactures',
  initialState,
  reducers: {
    setManufacturesList: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.manufactureList = payload || [];
      state.reset = false;
    },
    reset: (state) => {
      state.reset = true;
    }
  }
});

export const { setManufacturesList, reset } = slice.actions;

export default slice.reducer;
